import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import classRoomLayout from './layouts/classRoomLayout'
import mockTestLayout from './layouts/mockTestLayout'
import xinaoZoneLayout from './layouts/xinaoZoneLayout'
import FullScreenLayout from './layouts/FullScreenLayout'
import BlankLayout from '@/components/layouts/BlankLayout'

const whiteList = ['/user/login', '/home'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  if (Vue.ls.get(ACCESS_TOKEN)) {
    next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath, role: Vue.ls.get(USER_ROLE) } })
    } else {
      next()
    }
  }
})

let tenantConfig = store.getters.tenantInfo

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "wuge" */ './views/index'),
        meta:{title:'首页'}
      },

    ]
  },
  // classroom
  {
    path: '/classroom',
    component: classRoomLayout,
    redirect: '/classroom/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/home'),
        meta:{title:'我的教室'}
      }, {
        path: 'myClass',
        name: 'myClass',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/myClass'),
        meta:{title:'我的教室'}
      },{
        path: 'studentMyclass',
        name: 'studentMyclass',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/studentMyclass'),
        meta:{title:'我的教室',key:'studentMyclass'}
      }, {
        path: 'classDetails',
        name: 'classDetails',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classDetails'),
        meta:{
          key:'myClass',title:'我的教室'
        }
      }, {
        path: 'classroomComments',
        name: 'classroomComments',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classroomComments'),
        meta:{title:'我的教室'}
      }, {
        path: 'myWorks',
        name: 'myWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/myWorks'),
        meta:{title:'我的教室',name:'我的作品',key:'zuoping'}
      }, {
        path: 'classWorks',
        name: 'classWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classWorks'),
        meta:{title:'我的教室',name:'班级作品',key:'zuoping'}
      }, {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/WorkDetail'),
        meta:{title:'我的教室'}
      }, {
        path: 'mdView',
        name: 'mdView',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/MarkdownView'),
        meta:{title:'我的教室'}

      },{
        path: 'studentWorks',
        name: 'studentWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/studentWorks'),
        meta:{title:'我的教室',}
      },{
        path: 'LessonPreparationCenter',
        name: 'LessonPreparationCenter',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/LessonPreparationCenter'),
        meta:{title:'我的教室'}
      },{
        path: 'courseDetail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/CourseDetail'),
        meta:{title:'我的教室'}
      },{
        path: 'trainingForTeachers',
        name: 'trainingForTeachers',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/trainingForTeachers'),
        meta:{title:'我的教室'}
      },{
        path: 'teachingActivities',
        name: 'teachingActivities',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/teachingActivities'),
        meta:{title:'我的教室'}
      }, {
        path: 'CmsDetail',
        name: 'CmsDetail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/CmsDetail'),
        meta:{title:'我的教室'}
      },
    ]
  },
  {
    path: '/mockTest',
    component: mockTestLayout,
    redirect: '/mockTest/practise',
    children: [
      {
        path: 'practise',
        name: 'practise',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/practise'),
        meta:{title:'模拟测试',name:'我的练习'}
      },  {
        path: 'takeanexam',
        name: 'takeanexam',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/takeanexam'),
        meta:{title:'模拟测试',name:'我的考试'}
      },  {
        path: 'wrongQuestion',
        name: 'wrongQuestion',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/wrongQuestion'),
        meta:{title:'模拟测试',name:'错题集'}
      }, {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/questionBank'),
        meta:{title:'模拟测试',name:'题库中心'}
      },  {
        path: 'testPaper',
        name: 'testPaper',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/testPaper'),
        meta:{title:'模拟测试',name:'试卷中心'}
      }, {
        path: 'preview',
        name: 'paperPreview',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/PaperPreview'),
        meta:{title:'模拟测试',name:'试卷中心'}
      }, {
        path: 'studentPractice',
        name: 'studentPractice',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/studentPractice'),
        meta:{title:'模拟测试',name:'学员练习'}
      }, {
        path: 'studentExams',
        name: 'studentExams',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/studentExams'),
        meta:{title:'模拟测试',name:'学员考试'}
      }, 
    ]
  },
 
  // xinaoZoneLayout
  {
    path: '/xinaoZone',
    component: xinaoZoneLayout,
    redirect: '/xinaoZone/questionBank',
    children: [
      {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import(/* webpackChunkName: "wuge" */ './views/xinaoZone/questionBank'),
        meta:{title:'信奥专区'}
      },   {
        path: 'team',
        name: 'team',
        component: () => import(/* webpackChunkName: "wuge" */ './views/xinaoZone/team'),
        meta:{title:'信奥专区'}
      },    {
        path: 'Contest',
        name: 'Contest',
        component: () => import(/* webpackChunkName: "wuge" */ './views/xinaoZone/Contest'),
        meta:{title:'信奥专区'}
      },    {
        path: 'Ranking',
        name: 'Ranking',
        component: () => import(/* webpackChunkName: "wuge" */ './views/xinaoZone/Ranking'),
        meta:{title:'信奥专区'}
      },   
    ]
  },
  {
    path: '/work',
    component: HomeLayout,
    redirect: '/work/list',
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "wuge" */ './views/work/WorkList'),
        meta:{title:'作品社区'}
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/work/WorkDetail')
      },

      {
        path: 'mdEditor',
        name: 'mdEditor',
        component: () => import(/* webpackChunkName: "wuge" */ './views/work/MarkdownEditor')
      },
     
    ]
  },
  {
    path: '/cms',
    component: HomeLayout,
    redirect: '/cms/list',
    children: [
      {
        path: 'index',
        name: 'cmsIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CmsListAuto')
      },
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cms/CmsList')
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cms/CmsDetail')
      },
    ]
  },
  {
    path: '/cert',
    component: BlankLayout,
    redirect: '/cert/query',
    hidden: true,
    children: [
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/CertQuery')
      },
      // {
      //   path: '/cert/score',
      //   name: 'scoreQuery',
      //   component: () => import(/* webpackChunkName: "wuge" */ './views/ScoreQuery')
      // },
      {
        path: '/cert/studentReport',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/StudentCategoryReport')
      },
      {
        path: '/cert/schoolReport',
        name: 'schoolReport',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/SchoolCategoryReport')
      }
    ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "wuge" */ '@/components/exam/Examine')
  },
  {
    path: '/',
    component: FullScreenLayout,
    // redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "wuge" */ './views/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "wuge" */ './views/Register')
      }, {
        path: 'composing',
        name: 'paperComposing',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/PaperComposing'),
        meta:{title:'模拟测试',name:'组卷'}
      },{
        path: 'paper',
        name: 'PaperReport',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/PaperReport'),
        meta:{title:'模拟测试',name:'试卷报告'}
      },{
        path: 'examReview',
        name: 'examReview',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/ExamReview'),
        meta:{title:'模拟测试',name:'试卷批改'}
      },
    ]
    }
]
export default RouterMap